import React, { Component } from "react";
import ThreeSixty from "react-360-view";
import gsap from "gsap";

const wheel1 = "/img/icon-wheel-1.jpg";
const wheel2 = "/img/icon-wheel-2.jpg";
const wheel3 = "/img/icon-wheel-3.jpg";

export default class ChooseCarColor extends Component {
  state = {
    imgSrc: "images-black/images-black-1/",
    id: 1,
    w1: "w1",
    w2: "w2",
    w3: "w3",
    flag: 0,
    logID: "",
    logWID: "w1",
    wFlag: 0,
    isColorSelected: false,
  };
  canvasRef = React.createRef();
  titleRef = React.createRef();
  exteriorRef = React.createRef();
  wheelRef = React.createRef();

  carList = [
    {
      id: 1,
      title: "Crystal Black",
      type: "Pearl",
      img: "./images/icons/icon-black.jpg",
      srcImg: "images-black/images-black-1/",
      color: "Black",
      price: "19,550",
      engineType: "In-Line 4-Cylinder",
      displacement: "1996 cc",
      horsepower: "158 @ 6500 rpm",
      torque: "138 lb-ft @ 4200 rpm",
      redline: "6700 rpm",
      wheels: [
        {
          idWheel: 1,
          srcImg: "images-black/images-black-1/",
        },
        {
          idWheel: 2,
          srcImg: "images-black/images-black-2/",
        },
        {
          idWheel: 3,
          srcImg: "images-black/images-black-3/",
        },
      ],
    },
    {
      id: 2,
      title: "Modern Steel",
      type: "Metallic",
      img: "./images/icons/icon-steel.jpg",
      srcImg: "images-steel/images-steel-1/",
      color: "Steel",
      price: "20,550",
      engineType: "In-Line 4-Cylinder",
      displacement: "1996 cc",
      horsepower: "158 @ 6500 rpm",
      torque: "138 lb-ft @ 4200 rpm",
      redline: "6700 rpm",
      wheels: [
        {
          idWheel: 1,
          srcImg: "images-steel/images-steel-1/",
        },
        {
          idWheel: 2,
          srcImg: "images-steel/images-steel-2/",
        },
        {
          idWheel: 3,
          srcImg: "images-steel/images-steel-3/",
        },
      ],
    },
    {
      id: 3,
      title: "Lunar Silver",
      type: "Metallic",
      img: "./images/icons/icon-silver.jpg",
      srcImg: "images-silver/images-silver-1/",
      color: "Silver",
      price: "21,550",
      engineType: "In-Line 4-Cylinder",
      displacement: "1996 cc",
      horsepower: "158 @ 6500 rpm",
      torque: "138 lb-ft @ 4200 rpm",
      redline: "6700 rpm",
      wheels: [
        {
          idWheel: 1,
          srcImg: "images-silver/images-silver-1/",
        },
        {
          idWheel: 2,
          srcImg: "images-silver/images-silver-2/",
        },
        {
          idWheel: 3,
          srcImg: "images-silver/images-silver-3/",
        },
      ],
    },
    {
      id: 4,
      title: "Rallye Red",
      type: "Metallic",
      img: "./images/icons/icon-red.jpg",
      srcImg: "images-red/images-red-1/",
      color: "Red",
      price: "22,550",
      engineType: "In-Line 4-Cylinder",
      displacement: "1996 cc",
      horsepower: "158 @ 6500 rpm",
      torque: "138 lb-ft @ 4200 rpm",
      redline: "6700 rpm",
      wheels: [
        {
          idWheel: 1,
          srcImg: "images-red/images-red-1/",
        },
        {
          idWheel: 2,
          srcImg: "images-red/images-red-2/",
        },
        {
          idWheel: 3,
          srcImg: "images-red/images-red-3/",
        },
      ],
    },
  ];

  componentDidMount() {
    const tl = gsap.timeline();

    // Animation for canvas
    tl.fromTo(
      this.canvasRef.current,
      { opacity: 0, y: -100 },
      { opacity: 1, y: 0, duration: 1.9, ease: 'power3.out' }
    );

    // Animation for title
    tl.fromTo(
      this.titleRef.current,
      { opacity: 0, y: 50, scale: 0.5 },
      { opacity: 1, y: 0, scale: 1, duration: 1.4, ease: 'bounce.out' },
      '-=0.5'
    );

    // Animation for exterior
    tl.fromTo(
      this.exteriorRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1.5, ease: 'power3.out' },
      '-=0.5'
    );

    // Animation for wheel div
    tl.fromTo(
      this.wheelRef.current,
      { opacity: 0, x: 100 },
      { opacity: 1, x: 0, duration: 1.5, ease: 'power3.out' },
      '-=0.5'
    );
  }

  handleScroll = () => {
    // Triggering animations on scroll
    const tl = gsap.timeline();

    tl.fromTo(
      this.canvasRef.current,
      { opacity: 0, y: -100 },
      { opacity: 1, y: 0, duration: 1.9, ease: 'power3.out' }
    );

    tl.fromTo(
      this.titleRef.current,
      { opacity: 0, y: 50, scale: 0.5 },
      { opacity: 1, y: 0, scale: 1, duration: 1.4, ease: 'bounce.out' },
      '-=0.5'
    );

    tl.fromTo(
      this.exteriorRef.current,
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1.5, ease: 'power3.out' },
      '-=0.5'
    );

    tl.fromTo(
      this.wheelRef.current,
    { opacity: 0, x: 100 },
      { opacity: 1, x: 0, duration: 1.5, ease: 'power3.out' },
      '-=0.5'
    );
  };

  renderCarList = (id) => {
    return this.carList
      .filter((car) => car.id === id)
      .map((car, index) => {
        const {
          color,
          price,
          engineType,
          displacement,
          horsepower,
          torque,
          redline,
        } = car;
        return (
         
          <table className="table-auto w-full text-md text-white"  key={index} >
            <tbody>
              <tr className="border-b ">
                <td className="font-semibold py-2">Color</td>
                <td className="text-gray-400">{color}</td>
              </tr>
              <tr className="border-b">
                <td className="font-semibold py-2">Price</td>
                <td className="text-gray-400">${price}</td>
              </tr>
              <tr className="border-b">
                <td className="font-semibold py-2">Engine Type</td>
                <td className="text-gray-400">{engineType}</td>
              </tr>
              <tr className="border-b">
                <td className="font-semibold py-2">Displacement</td>
                <td className="text-gray-400">{displacement}</td>
              </tr>
              <tr className="border-b">
                <td className="font-semibold py-2">Horsepower</td>
                <td className="text-gray-400">{horsepower}</td>
              </tr>
              <tr className="border-b">
                <td className="font-semibold py-2">Torque</td>
                <td className="text-gray-400">{torque}</td>
              </tr>
              <tr className="border-b">
                <td className="font-semibold py-2">Redline</td>
                <td className="text-gray-400">{redline}</td>
              </tr>
            </tbody>
          </table>
          
        );
      });
  };

  handleChangeColor = (cid) => {
    const {  flag, logID, logWID } = this.state;
    this.setState({
      id: cid,
      isColorSelected: true, // Set color selected to true when a color is chosen
    });

    document.getElementById("carDefault").style.display = "none";
    if (flag === 0) {
      this.setState({
        flag: 1,
        logID: cid,
      });
    } else {
      document.getElementById(`${logWID}`).style.display = "none";
      document.getElementById(`c${logID}`).style.display = "none";
      this.setState({
        logID: cid,
      });
    }
    
    document.getElementById(`c${cid}`).style.display = "block";
     // eslint-disable-next-line 
    switch (cid) {
      case 1:
        this.setState({
          w1: "w1",
          w2: "w2",
          w3: "w3",
        });
        break;
      case 2:
        this.setState({
          w1: "w4",
          w2: "w5",
          w3: "w6",
        });
        break;
      case 3:
        this.setState({
          w1: "w7",
          w2: "w8",
          w3: "w9",
        });
        break;
      case 4:
        this.setState({
          w1: "w10",
          w2: "w11",
          w3: "w12",
        });
        break;
    }
  };

  renderCar360 = () => {
    return this.carList.map((car) => {
      return (
        <div
          className="carContent w-full"
          id={`c${car.id}`}
          style={{ display: "none" }}
          
        >
          <ThreeSixty
            amount={8}
            imagePath={`./img/${car.srcImg}`}
            fileName="civic-{index}.jpg"
          />
        </div>
      );
    });
  };

  renderCarWheel360 = () => {
    let id = 0;
    return this.carList.map((car) => {
      return car.wheels.map((wheel) => {
        id++;
        return (
          <div className="carContent"  id={`w${id}`} style={{ display: "none" }}>
            <ThreeSixty
              amount={8}
              imagePath={`./img/${wheel.srcImg}`}
              fileName="civic-{index}.jpg"
            />
          </div>
        );
      });
    });
  };

  renderCarWheel = (wID) => {
    const { logID, logWID, wFlag } = this.state;

    document.getElementById(`c${logID}`).style.display = "none";
    document.getElementById(`${logWID}`).style.display = "none";
    if (wFlag === 0) {
      this.setState({
        logWID: wID,
        wFlag: 1,
      });
      document.getElementById(`${wID}`).style.display = "block";
    } else {
      this.setState({
        logWID: wID,
      });
    }
    document.getElementById(`${wID}`).style.display = "block";
  };

  render() {
    const {  id, w1, w2, w3, isColorSelected } = this.state;


    return (
      <div className="container mx-auto space-x-14 lg:px-4 px-10 py-9 rounded-3xl mt-[9%]  bg-slate-900">
        <h1 className="text-4xl sm:text-6xl font-semibold text-center text-white mb-10" ref={this.titleRef}>
          Choose Your Car Color & Features
        </h1>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          <div className="car-section">
            <div className="car-360-view">
              {this.renderCar360()}
              {this.renderCarWheel360()}
              <div id="carDefault" className="w-full max-w-md mx-auto">
                <ThreeSixty
                  amount={8}
                  imagePath={`./img/images-black/images-black-1/`}
                  fileName="civic-{index}.jpg"
                />
              </div>
            </div>
    
            <div className="car-details mt-3 shadow-lg rounded-lg bg-slate-800" ref={this.exteriorRef}>
              <h1 className="text-2xl sm:text-3xl py-6 text-center text-white">Car Details</h1>
              <div className="p-8">
                {this.renderCarList(id)}
              </div>
            </div>
          </div>
    
          <div className="side-panel">
            <div className="color-selection card shadow-xl bg-gray-800 text-white rounded-lg" ref={this.canvasRef}>
              <div className="card-header px-6 py-4 border-b">
                <h3 className="text-xl sm:text-2xl font-semibold">Exterior Color</h3>
              </div>
              <ul className="grid lg:grid-cols-2 grid-cols-2 gap-4 px-4 py-4"> {/* Adjusted to grid-cols-2 on small screens */}
                {this.carList.map((car) => {
                  let circleColor;
                  // Map car color to the provided colors
                  switch (car.color.toLowerCase()) {
                    case 'black':
                      circleColor = '#343232'; // Dark gray
                      break;
                    case 'steel':
                      circleColor = '#828282'; // Light gray
                      break;
                    case 'silver':
                      circleColor = '#a2a0a5'; // Silver
                      break;
                    case 'red':
                      circleColor = '#ff646a'; // Red
                      break;
                    default:
                      circleColor = '#828282'; // Default to light gray
                  }
    
                  return (
                    <li
                      key={car.id}
                      onClick={() => this.handleChangeColor(car.id)}
                      className="cursor-pointer hover:bg-gray-700 p-3 rounded-lg flex items-center space-x-4 mb-3 transition"
                    >
                      {/* Circle with the defined color */}
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: circleColor,
                        }}
                        className="flex-shrink-0"
                      ></div>
                      <span className="font-semibold">{car.title}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
    
            <div className="wheel-selection card mt-10 shadow-xl bg-gray-700 rounded-lg text-white" ref={this.wheelRef}>
              <div className="card-header px-7 py-7 border-b border-black">
              
              
              {!isColorSelected && (
          <div className="message text-yellow-200 mb-4 text-lg font-semibold" >
            Select a color to see the wheel options!
          </div>
        )}
                <h3 className="text-2xl sm:text-3xl font-semibold">Wheels</h3>
              </div>
    
              <ul className="grid lg:grid-cols-3 grid-cols-1 gap-4 px-4 py-4">
                <li
                  onClick={() => this.renderCarWheel(w1)}
                  className="cursor-pointer hover:bg-gray-800 p-3 rounded-lg mb-3 transition flex items-center gap-3"
                >
                  <img src={wheel1} alt="Wheel 1" className="w-20 lg:w-28 h-20 lg:h-33 object-contain" />
                  <p className="text-sm lg:text-lg font-bold">Wheel 1</p>
                </li>
                <li
                  onClick={() => this.renderCarWheel(w2)}
                  className="cursor-pointer hover:bg-gray-800 p-3 rounded-lg mb-3 transition flex items-center gap-3"
                >
                  <img src={wheel2} alt="Wheel 2" className="w-20 lg:w-28 h-20 lg:h-33 object-contain" />
                  <p className="text-sm lg:text-lg font-bold">Wheel 2</p>
                </li>
                <li
                  onClick={() => this.renderCarWheel(w3)}
                  className="cursor-pointer hover:bg-gray-800 p-3 rounded-lg mb-3 transition flex items-center gap-3"
                >
                  <img src={wheel3} alt="Wheel 3" className="w-20 lg:w-28 h-20 lg:h-33 object-contain" />
                  <p className="text-sm lg:text-lg font-bold">Wheel 3</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
        }
}